module.exports = __webpack_public_path__ + "img/pdt_metalwarmint.b0dfbd1.png";